<div class="modal is-active">
  <div (click)="close(false)" class="modal-background"></div>
  <div class="modal-card">
    <header class="modal-card-head">
      <h2 class="title is-4 modal-card-title has-text-weight-bold">
        Order incentives
      </h2>
    </header>
    <div class="modal-card-body pt-0">
      <p class="mb-2">
        You can order the display of incentives in the comparator view using
        drag and drop
      </p>

      <div dndDropzone (dndDrop)="onDrop($event)" class="main-dropzone">
        <div
          *ngFor="let incentive of incentives; let i = index"
          [dndDraggable]="incentive"
          [dndEffectAllowed]="'copyMove'"
          dndEffectAllowed="move"
          (dndMoved)="onDrag(incentive)"
          class="card is-bordered is-shadowless mb-2 is-draggable"
        >
          <div
            class="card-content is-flex is-align-items-center is-justify-content-flex-start"
          >
            <div
              class="is-flex is-align-items-center is-justify-content-flex-start"
            >
              <i class="fa-solid fa-grip-vertical mr-2"></i>
              <img
                class="flag is-small mr-2"
                src="./assets/images/flags/{{ incentive.country.image }}.png"
                alt="{{ incentive.country.label }} flag"
              />
              <span class="content is-small"> {{ incentive.label }} </span>
            </div>
          </div>
        </div>
        <div
          class="card is-bordered is-shadowless mb-2 has-background-grey-lighter"
          dndPlaceholderRef
        ></div>
      </div>

      <footer
        class="modal-card-foot is-flex is-align-items-center is-justify-content-space-between px-0 pb-0"
      >
        <button (click)="close(false)" class="button">Cancel</button>
        <button (click)="close(true)" class="button is-link">
          Save changes
        </button>
      </footer>
    </div>
    <button
      (click)="close(false)"
      class="modal-close is-large"
      aria-label="close"
    ></button>
  </div>
</div>
